/*
  Complementos FLP en la ficha de producto (snippets/flp-complementos-ficha.liquid).

  - Las casillas y los puntos de color llegan desactivados; este archivo los activa. Si falla al
    arrancar, el bloque se oculta.
  - Los complementos marcados se añaden con el MISMO botón que el producto, en UNA sola llamada a
    /cart/add.js con items[] (producto principal primero). Sin complementos nuevos marcados no se
    intercepta nada: el botón funciona exactamente como en el tema.
  - Cada complemento va con cantidad 1 y la propiedad "Complemento para" = título del producto.
  - COLOR: si el complemento tiene varias variantes, la tarjeta trae una fila de puntos. El punto
    elegido se guarda reescribiendo data-variant-id y data-price de la casilla, así que el carrito,
    el total y el bloqueo siguen leyendo lo mismo que cuando había una sola variante.
  - Si ya está en el carrito para este producto: marcado y bloqueado, con "Ya en tu carrito". Vale
    cualquier variante del complemento, y la tarjeta sale con ese color.
  - Con alguno marcado o bloqueado se ocultan los pagos exprés, que no pasan por el submit.
  - "Ver N más" abre las casillas que llegan ocultas a partir del máximo visible.
  - Con complementos nuevos marcados se enseña el total (producto x cantidad + complementos), con el
    formato de moneda de la tienda. Se recalcula al marcar, al cambiar de variante y de cantidad.
*/
(function () {
  'use strict';

  if (window.FlpComplementos) {
    window.FlpComplementos.iniciarTodos(document);
    return;
  }

  var PROPIEDAD = 'Complemento para';
  var PROPIEDAD_ID = '_complemento_para_id'; // oculta en carrito y checkout; identifica el producto sin depender del título
  var CLASE_SIN_EXPRES = 'flpc-sin-expres';
  var MENSAJE_ERROR =
    'No hemos podido añadir los complementos. Vuelve a pulsar y se añadirá tu pedido sin ellos. ' +
    'Si quieres el complemento, llámanos al 658 76 88 66 y lo añadimos.';

  var bloquesPorFormulario = {};

  function rutaCarrito(root) {
    return (window.routes && window.routes.cart_url) || root.getAttribute('data-cart-url') || '/cart';
  }

  function rutaAnadir() {
    return ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
  }

  /* ---------- Dinero: mismo formato que el filtro money de la tienda (shop.money_format) ---------- */

  function conSeparadores(centimos, decimales, miles, coma) {
    var partes = (centimos / 100).toFixed(decimales).split('.');
    var entero = partes[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + miles);
    return entero + (partes[1] ? coma + partes[1] : '');
  }

  // sinCeros = como money_without_trailing_zeros: 30,00 € se escribe 30 €.
  function formatearDinero(centimos, formato, sinCeros) {
    var hueco = /\{\{\s*(\w+)\s*\}\}/;
    var m = formato.match(hueco);
    if (!m) return formato;
    var dec = sinCeros && centimos % 100 === 0 ? 0 : 2;
    var valor;
    switch (m[1]) {
      case 'amount':
        valor = conSeparadores(centimos, dec, ',', '.');
        break;
      case 'amount_no_decimals':
        valor = conSeparadores(centimos, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        valor = conSeparadores(centimos, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        valor = conSeparadores(centimos, dec, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        valor = conSeparadores(centimos, 0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        valor = conSeparadores(centimos, dec, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        valor = conSeparadores(centimos, dec, ' ', '.');
        break;
      default: // amount_with_comma_separator, el de esta tienda
        valor = conSeparadores(centimos, dec, '.', ',');
    }
    return formato.replace(hueco, valor);
  }

  /* ---------- Arranque ---------- */

  function iniciarTodos(ambito) {
    Array.prototype.forEach.call((ambito || document).querySelectorAll('[data-flpc]'), iniciar);
  }

  function iniciar(root) {
    if (root.hasAttribute('data-flpc-listo')) return;
    try {
      var bloque = crearBloque(root);
      bloque.checks.forEach(function (check) {
        check.disabled = false;
        prepararColores(bloque, check);
        check.addEventListener('change', function () {
          ocultarError(bloque);
          sincronizarColor(bloque, check);
          actualizar(bloque);
        });
      });
      bloque.carrito = leerCarrito(bloque)
        .then(function (cart) {
          marcarEnCarrito(bloque, cart);
        })
        .catch(function (e) {
          console.warn('[FLP complementos] No se pudo leer el carrito', e);
        });
      bloquesPorFormulario[bloque.form.id] = bloque;
      actualizar(bloque);
      root.setAttribute('data-flpc-listo', '');
    } catch (e) {
      ocultarBloque(root);
      console.error('[FLP complementos] Bloque ocultado por un error al arrancar', e);
    }
  }

  function crearBloque(root) {
    var form = document.getElementById(root.getAttribute('data-form-id'));
    var lista = root.querySelector('.flpc__lista');
    var error = root.querySelector('.flpc__error');
    var checks = Array.prototype.slice.call(root.querySelectorAll('.flpc__check'));
    if (!form || !lista || !error || !checks.length) throw new Error('Marcado o formulario de compra no encontrado');

    var aviso = document.createElement('p');
    aviso.className = 'flpc__aviso';
    aviso.hidden = true;
    lista.parentNode.insertBefore(aviso, lista);

    // Sin precios o sin formato no hay total, pero el bloque sigue vendiendo igual.
    var precios = null;
    try {
      precios = JSON.parse(root.querySelector('[data-flpc-precios]').textContent);
    } catch (e) {
      console.warn('[FLP complementos] Sin precios para el total', e);
    }

    var bloque = {
      root: root,
      form: form,
      host: root.closest('product-info') || document.body,
      titulo: root.getAttribute('data-product-title'),
      productoId: root.getAttribute('data-product-id'),
      checks: checks,
      error: error,
      aviso: aviso,
      mas: root.querySelector('.flpc__mas'),
      total: root.querySelector('.flpc__total'),
      totalDetalle: root.querySelector('.flpc__total-detalle'),
      totalImporte: root.querySelector('.flpc__total-importe'),
      precios: precios,
      formatoDinero: root.getAttribute('data-money-format') || '',
      carrito: Promise.resolve(),
      enviando: false,
    };

    // "Ver N más": las casillas de más llegan ocultas, y el botón también. Solo el JS las abre.
    if (bloque.mas) {
      bloque.mas.addEventListener('click', function () {
        Array.prototype.forEach.call(root.querySelectorAll('.flpc__item--extra'), function (item) {
          item.hidden = false;
        });
        bloque.mas.setAttribute('aria-expanded', 'true');
        bloque.mas.hidden = true;
      });
      actualizarMas(bloque);
    }

    return bloque;
  }

  // Cuántas casillas quedan escondidas. Si no queda ninguna, el botón sobra.
  function actualizarMas(bloque) {
    if (!bloque.mas) return;
    var ocultas = Array.prototype.filter.call(bloque.root.querySelectorAll('.flpc__item--extra'), function (item) {
      return item.hidden;
    }).length;
    if (!ocultas) {
      bloque.mas.hidden = true;
      return;
    }
    bloque.mas.textContent = 'Ver ' + ocultas + ' más';
    bloque.mas.hidden = false;
  }

  function ocultarBloque(root) {
    root.hidden = true;
    var host = root.closest('product-info');
    if (host) host.classList.remove(CLASE_SIN_EXPRES);
    var formId = root.getAttribute('data-form-id');
    if (bloquesPorFormulario[formId] && bloquesPorFormulario[formId].root === root) {
      delete bloquesPorFormulario[formId];
    }
  }

  /* ---------- Puntos de color ---------- */

  function itemDe(check) {
    return check.closest('.flpc__item');
  }

  // Vacío en los complementos de una sola variante: ahí no hay nada que elegir.
  function puntosDe(check) {
    var item = itemDe(check);
    return item ? Array.prototype.slice.call(item.querySelectorAll('.flpc__punto')) : [];
  }

  function puntoElegido(check) {
    return (
      puntosDe(check).filter(function (punto) {
        return punto.getAttribute('aria-pressed') === 'true';
      })[0] || null
    );
  }

  function prepararColores(bloque, check) {
    var puntos = puntosDe(check);
    if (!puntos.length) return;

    // La foto del producto, para poder volver a ella al desmarcar.
    var img = itemDe(check).querySelector('.flpc__img');
    if (img && !img.hasAttribute('data-flpc-src-base')) {
      img.setAttribute('data-flpc-src-base', img.getAttribute('src') || '');
      img.setAttribute('data-flpc-srcset-base', img.getAttribute('srcset') || '');
      img.setAttribute('data-flpc-alt-base', img.getAttribute('alt') || '');
    }

    puntos.forEach(function (punto) {
      punto.disabled = false;
      punto.addEventListener('click', function () {
        if (check.disabled) return;
        ocultarError(bloque);
        if (punto.getAttribute('aria-pressed') === 'true') {
          // El mismo punto otra vez: se suelta el color y la tarjeta queda sin marcar.
          quitarColor(bloque, check);
          check.checked = false;
        } else {
          ponerColor(bloque, check, punto);
          check.checked = true;
        }
        actualizar(bloque);
      });
    });
  }

  // El color elegido manda: variante que se añade, foto y precio de la tarjeta.
  function ponerColor(bloque, check, punto) {
    puntosDe(check).forEach(function (otro) {
      otro.setAttribute('aria-pressed', otro === punto ? 'true' : 'false');
    });
    check.setAttribute('data-variant-id', punto.getAttribute('data-variant-id'));
    check.setAttribute('data-price', punto.getAttribute('data-price'));

    var img = itemDe(check).querySelector('.flpc__img');
    var src = punto.getAttribute('data-img');
    if (img && src) {
      // Hay que quitar srcset: con él puesto, el navegador ignora el src nuevo.
      img.removeAttribute('srcset');
      img.setAttribute('src', src);
      img.setAttribute('alt', punto.getAttribute('data-alt') || img.getAttribute('alt') || '');
    }
    escribirPrecio(bloque, check, punto.getAttribute('data-price'));
  }

  // Sin color elegido se vuelve al primero: así, si luego se marca la tarjeta por la foto,
  // se añade el primer color y no el último que se tocó.
  function quitarColor(bloque, check) {
    var puntos = puntosDe(check);
    if (!puntos.length) return;
    puntos.forEach(function (punto) {
      punto.setAttribute('aria-pressed', 'false');
    });
    check.setAttribute('data-variant-id', puntos[0].getAttribute('data-variant-id'));
    check.setAttribute('data-price', puntos[0].getAttribute('data-price'));

    var img = itemDe(check).querySelector('.flpc__img');
    if (img && img.hasAttribute('data-flpc-src-base')) {
      var base = img.getAttribute('data-flpc-src-base');
      var srcset = img.getAttribute('data-flpc-srcset-base');
      if (base) img.setAttribute('src', base);
      if (srcset) {
        img.setAttribute('srcset', srcset);
      } else {
        img.removeAttribute('srcset');
      }
      img.setAttribute('alt', img.getAttribute('data-flpc-alt-base') || '');
    }
    escribirPrecio(bloque, check, puntos[0].getAttribute('data-price'));
  }

  // Marcar la tarjeta sin tocar ningún punto elige el primer color; desmarcarla los suelta.
  function sincronizarColor(bloque, check) {
    var puntos = puntosDe(check);
    if (!puntos.length) return;
    var elegido = puntoElegido(check);
    if (check.checked && !elegido) {
      ponerColor(bloque, check, puntos[0]);
    } else if (!check.checked && elegido) {
      quitarColor(bloque, check);
    }
  }

  // Con varias variantes el precio puede cambiar según el color.
  function escribirPrecio(bloque, check, centimos) {
    var etiqueta = itemDe(check).querySelector('.flpc__precio');
    var n = parseInt(centimos, 10);
    if (!etiqueta || isNaN(n) || !bloque.formatoDinero) return;
    etiqueta.textContent = '+' + formatearDinero(n, bloque.formatoDinero, true);
  }

  /* ---------- Estado visible ---------- */

  function nuevosMarcados(bloque) {
    return bloque.checks.filter(function (check) {
      return check.checked && !check.hasAttribute('data-en-carrito');
    });
  }

  function cantidadPrincipal(bloque) {
    var input = bloque.form.elements.namedItem('quantity');
    var n = input && input.value ? parseInt(input.value, 10) : 1;
    return n > 0 ? n : 1;
  }

  function actualizar(bloque) {
    var hayMarcados = bloque.checks.some(function (check) {
      return check.checked;
    });
    bloque.host.classList.toggle(CLASE_SIN_EXPRES, hayMarcados);

    var n = cantidadPrincipal(bloque);
    if (n > 1 && nuevosMarcados(bloque).length > 0) {
      bloque.aviso.textContent = 'Pides ' + n + ' unidades: se añade 1 de cada complemento marcado.';
      bloque.aviso.hidden = false;
    } else {
      bloque.aviso.hidden = true;
    }

    actualizarTotal(bloque);
  }

  // Lo que suma este clic: producto (variante elegida x cantidad) + complementos nuevos marcados.
  // Lo que ya estaba en el carrito no cuenta. Si falta cualquier dato, el total no se enseña.
  function actualizarTotal(bloque) {
    if (!bloque.total) return;
    try {
      var marcados = nuevosMarcados(bloque);
      var variante = bloque.form.querySelector('[name="id"]');
      var idVariante = variante && !variante.disabled ? variante.value : '';
      var precio = bloque.precios && idVariante ? bloque.precios[idVariante] : undefined;
      if (!marcados.length || typeof precio !== 'number' || !bloque.formatoDinero) {
        bloque.total.hidden = true;
        return;
      }

      var cantidad = cantidadPrincipal(bloque);
      var sumaComplementos = 0;
      for (var i = 0; i < marcados.length; i++) {
        var p = parseInt(marcados[i].getAttribute('data-price'), 10);
        if (isNaN(p)) {
          bloque.total.hidden = true;
          return;
        }
        sumaComplementos += p;
      }

      var f = bloque.formatoDinero;
      var producto = (cantidad > 1 ? cantidad + ' × ' : '') + formatearDinero(precio, f, true);
      var complementos =
        marcados.length + (marcados.length === 1 ? ' complemento ' : ' complementos ') + formatearDinero(sumaComplementos, f, true);

      bloque.totalDetalle.textContent = producto + ' + ' + complementos;
      bloque.totalImporte.textContent = formatearDinero(precio * cantidad + sumaComplementos, f, true);
      bloque.total.hidden = false;
    } catch (e) {
      bloque.total.hidden = true;
      console.warn('[FLP complementos] No se pudo calcular el total', e);
    }
  }

  function mostrarError(bloque) {
    bloque.error.textContent = MENSAJE_ERROR;
    bloque.error.hidden = false;
  }

  function ocultarError(bloque) {
    bloque.error.hidden = true;
    bloque.error.textContent = '';
  }

  /* ---------- Carrito ---------- */

  function leerCarrito(bloque) {
    return fetch(rutaCarrito(bloque.root) + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('cart.js ' + r.status);
      return r.json();
    });
  }

  // Bloquea (marcado y sin poder desmarcar) lo que ya está en el carrito como complemento de ESTE
  // producto. Con varias variantes vale cualquiera: la tarjeta sale con el color que ya está dentro.
  function marcarEnCarrito(bloque, cart) {
    var enCarrito = {};
    (cart.items || []).forEach(function (item) {
      if (item.properties && item.properties[PROPIEDAD_ID] === bloque.productoId) {
        enCarrito[String(item.variant_id)] = true;
      }
    });
    bloque.checks.forEach(function (check) {
      var puntos = puntosDe(check);
      var punto = null;
      if (puntos.length) {
        punto = puntos.filter(function (p) {
          return enCarrito[p.getAttribute('data-variant-id')];
        })[0];
        if (!punto) return;
        ponerColor(bloque, check, punto);
      } else if (!enCarrito[check.getAttribute('data-variant-id')]) {
        return;
      }
      check.checked = true;
      check.disabled = true;
      check.setAttribute('data-en-carrito', '');
      puntos.forEach(function (p) {
        p.disabled = true;
      });
      var item = itemDe(check);
      item.classList.add('flpc__item--en-carrito');
      // Si estaba escondido tras "Ver más", se saca a la vista: si no, el pago exprés
      // desaparecería sin que se vea el motivo.
      item.hidden = false;
      var nota = item.querySelector('.flpc__en-carrito');
      if (nota) nota.hidden = false;
    });
    actualizarMas(bloque);
    actualizar(bloque);
  }

  /* ---------- Compra ---------- */

  function articuloPrincipal(form) {
    var datos = new FormData(form);
    var articulo = {
      id: Number(datos.get('id')),
      quantity: parseInt(datos.get('quantity'), 10) || 1,
    };
    if (!articulo.id) throw new Error('Variante principal no válida');

    var propiedades = {};
    var hayPropiedades = false;
    datos.forEach(function (valor, clave) {
      var m = /^properties\[(.+)\]$/.exec(clave);
      if (!m) return;
      if (typeof valor !== 'string') throw new Error('Propiedad no textual: ' + m[1]);
      propiedades[m[1]] = valor;
      hayPropiedades = true;
    });
    if (hayPropiedades) articulo.properties = propiedades;

    var plan = datos.get('selling_plan');
    if (plan) articulo.selling_plan = Number(plan);
    return articulo;
  }

  function articulosComplemento(bloque) {
    return nuevosMarcados(bloque).map(function (check) {
      var propiedades = {};
      propiedades[PROPIEDAD] = bloque.titulo;
      propiedades[PROPIEDAD_ID] = bloque.productoId;
      return { id: Number(check.getAttribute('data-variant-id')), quantity: 1, properties: propiedades };
    });
  }

  function anadir(items) {
    return fetch(rutaAnadir(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      return r
        .json()
        .catch(function () {
          return {};
        })
        .then(function (datos) {
          if (!r.ok || datos.status) {
            var e = new Error('cart/add.js ' + r.status);
            e.codigo = 'INVALID';
            e.descripcion = typeof datos.description === 'string' ? datos.description : '';
            e.mensajeCarrito = datos.description || datos.message;
            e.errores = datos.errors || datos.description;
            e.mensaje = datos.message;
            throw e;
          }
          return datos;
        });
    });
  }

  /* ---------- Eventos estándar: los mismos que emite assets/product-form.js ---------- */

  function elementoProductForm(bloque) {
    return bloque.form.closest('product-form') || bloque.form;
  }

  // Como createCartLinesUpdateEvent(variantId, quantity) del tema, con una línea por artículo de la llamada.
  function crearEventoLineas(bloque, items) {
    var CartLinesUpdateEvent = (window.StandardEvents || {}).CartLinesUpdateEvent;
    if (!CartLinesUpdateEvent) return null;

    var deferred = CartLinesUpdateEvent.createPromise();
    elementoProductForm(bloque).dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: items.map(function (item) {
          return { merchandiseId: String(item.id), quantity: item.quantity };
        }),
        promise: deferred.promise,
      })
    );
    return deferred;
  }

  // Como resolveCartLinesUpdate(deferred) del tema.
  function resolverEventoLineas(bloque, deferred) {
    var CartLinesUpdateEvent = (window.StandardEvents || {}).CartLinesUpdateEvent;
    if (!deferred || !CartLinesUpdateEvent) return Promise.resolve();

    var carritoPendiente =
      typeof CartItems !== 'undefined'
        ? CartItems.fetchCartData()
        : fetch(rutaCarrito(bloque.root) + '.json').then(function (r) {
            return r.json();
          });

    return carritoPendiente
      .then(function (cart) {
        if (!cart || !cart.currency) return deferred.reject(new Error('Missing currency in cart response'));
        deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
      })
      .catch(function (e) {
        deferred.reject(e);
      });
  }

  // Como el camino de error del tema: publish(cartError) + dispatchCartErrorEvent + reject del evento de líneas.
  function emitirErrorCarrito(bloque, deferred, items, e) {
    var codigo = e && e.codigo ? e.codigo : 'SERVICE_UNAVAILABLE';
    var mensaje = codigo === 'INVALID' ? e.mensajeCarrito : (e && e.message) || 'Network error';

    if (codigo === 'INVALID' && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'product-form',
        productVariantId: String(items[0].id),
        errors: e.errores,
        message: e.mensaje,
      });
    }

    var CartErrorEvent = (window.StandardEvents || {}).CartErrorEvent;
    if (CartErrorEvent) elementoProductForm(bloque).dispatchEvent(new CartErrorEvent({ error: mensaje, code: codigo }));

    if (deferred) deferred.reject(codigo === 'INVALID' ? new Error(mensaje) : e);
  }

  function esperarComoMucho(promesa, ms) {
    return new Promise(function (resolve) {
      var temporizador = setTimeout(resolve, ms);
      promesa.then(
        function () {
          clearTimeout(temporizador);
          resolve();
        },
        function () {
          clearTimeout(temporizador);
          resolve();
        }
      );
    });
  }

  function botonCargando(form, boton, activo) {
    var productForm = form.closest('product-form');
    var spinner = productForm && productForm.querySelector('.loading__spinner');
    if (activo) {
      boton.setAttribute('aria-disabled', 'true');
      boton.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      boton.removeAttribute('aria-disabled');
      boton.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  // Caja de error estándar del botón de compra (la misma que usa product-form.js).
  function errorDelTema(form, texto) {
    var productForm = form.closest('product-form');
    var caja = productForm && productForm.querySelector('.product-form__error-message-wrapper');
    if (!caja) return;
    var mensaje = caja.querySelector('.product-form__error-message');
    if (texto && mensaje) mensaje.textContent = texto;
    caja.toggleAttribute('hidden', !texto);
  }

  function alEnviar(evt) {
    var form = evt.target;
    var bloque = form && form.id ? bloquesPorFormulario[form.id] : null;
    if (!bloque) return;

    try {
      if (bloque.enviando) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        return;
      }
      if (!nuevosMarcados(bloque).length) return; // sin complementos nuevos: compra normal del tema

      var boton = form.querySelector('[type="submit"]');
      var variante = form.querySelector('[name="id"]');
      if (!boton || boton.disabled || boton.getAttribute('aria-disabled') === 'true') return;
      if (!variante || variante.disabled || !variante.value) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();
      enviar(bloque, boton);
    } catch (e) {
      // Algo falló con complementos marcados: se frena para no mandar el pedido incompleto sin avisar.
      evt.preventDefault();
      evt.stopImmediatePropagation();
      console.error('[FLP complementos] Error al preparar el pedido', e);
      desmarcarNuevosYAvisar(bloque);
    }
  }

  function enviar(bloque, boton) {
    var items = null;
    var eventoLineas = null;
    var pedido = false;
    var anadido = false;

    bloque.enviando = true;
    ocultarError(bloque);
    errorDelTema(bloque.form, '');
    botonCargando(bloque.form, boton, true);

    bloque.carrito
      .then(function () {
        // Tras leer el carrito, lo que ya estaba queda bloqueado y no se vuelve a añadir.
        items = [articuloPrincipal(bloque.form)].concat(articulosComplemento(bloque));
        eventoLineas = crearEventoLineas(bloque, items);
        pedido = true;
        return anadir(items);
      })
      .then(function () {
        anadido = true;
        // El tema lanza la resolución del evento y redirige sin esperar. Aquí se espera
        // a que se resuelva (máximo 2 s) para que la redirección no lo corte.
        return esperarComoMucho(resolverEventoLineas(bloque, eventoLineas), 2000);
      })
      .then(function () {
        window.location.href = rutaCarrito(bloque.root);
      })
      .catch(function (e) {
        if (anadido) {
          window.location.href = rutaCarrito(bloque.root);
          return;
        }
        console.error('[FLP complementos] No se pudo añadir al carrito', e);
        if (pedido) emitirErrorCarrito(bloque, eventoLineas, items, e);
        if (e && e.descripcion) errorDelTema(bloque.form, e.descripcion);
        return leerCarrito(bloque)
          .then(function (cart) {
            marcarEnCarrito(bloque, cart);
          })
          .catch(function () {})
          .then(function () {
            desmarcarNuevosYAvisar(bloque);
            botonCargando(bloque.form, boton, false);
            bloque.enviando = false;
          });
      });
  }

  function desmarcarNuevosYAvisar(bloque) {
    var quedan = nuevosMarcados(bloque);
    quedan.forEach(function (check) {
      check.checked = false;
      quitarColor(bloque, check);
    });
    if (quedan.length) mostrarError(bloque);
    actualizar(bloque);
  }

  /* ---------- Eventos globales ---------- */

  document.addEventListener('submit', alEnviar, true);

  // Cantidad, y cambio de variante: Dawn (product-info.js, updateVariantInputs) cambia el input "id"
  // del formulario y dispara "change" en él. Si la variante no existe, lo deja vacío y el total se oculta.
  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input || (input.name !== 'quantity' && input.name !== 'id')) return;
    var bloque = bloquesPorFormulario[input.getAttribute('form') || (input.form && input.form.id)];
    if (bloque) actualizar(bloque);
  });

  // Al cambiar de variante, Dawn devuelve la cantidad al mínimo sin disparar "change" y lo avisa por quantityUpdate.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.quantityUpdate) {
    subscribe(PUB_SUB_EVENTS.quantityUpdate, function () {
      Object.keys(bloquesPorFormulario).forEach(function (formId) {
        try {
          actualizar(bloquesPorFormulario[formId]);
        } catch (e) {
          console.error('[FLP complementos] Error al actualizar tras cambio de cantidad', e);
        }
      });
    });
  }

  document.addEventListener('shopify:section:load', function (evt) {
    iniciarTodos(evt.target);
  });

  window.FlpComplementos = { iniciarTodos: iniciarTodos };
  iniciarTodos(document);
})();
